import { ADMIN_RESOURCE_REGISTRY } from './admin/admin-resource.registry.js';
import { DATA_RESOURCE_REGISTRY } from './data/data-resource.registry.js';
import { INSTRUMENTS_RESOURCE } from './data/reference-data-resource.registry.js';
import { ROUTE_IDS } from './routes/ids.js';
import { ORGANIZATION_BRANCHES_LIST, ORGANIZATION_BRANCHES_READ, ORGANIZATION_USERS_LIST, ORGANIZATION_USERS_READ, } from '../operations/operation-ids.js';
const transactions = DATA_RESOURCE_REGISTRY.transactions;
const clients = ADMIN_RESOURCE_REGISTRY['organization-client-accounts'];
const portfolios = ADMIN_RESOURCE_REGISTRY['organization-portfolios'];
if (!transactions.readOperationId || !transactions.detailRouteId)
    throw new Error('SMART_SEARCH_TRANSACTION_DETAIL_AUTHORITY_MISSING');
if (!clients.readOperationId || !clients.detailRouteId)
    throw new Error('SMART_SEARCH_CLIENT_DETAIL_AUTHORITY_MISSING');
if (!portfolios.readOperationId || !portfolios.detailRouteId)
    throw new Error('SMART_SEARCH_PORTFOLIO_DETAIL_AUTHORITY_MISSING');
if (!INSTRUMENTS_RESOURCE.readOperationId || !INSTRUMENTS_RESOURCE.detailRouteId)
    throw new Error('SMART_SEARCH_INSTRUMENT_DETAIL_AUTHORITY_MISSING');
export const SMART_SEARCH_RECORD_PROVIDER_REGISTRY = Object.freeze({
    branches: {
        id: 'branches',
        resourceId: 'organization-branches',
        entityType: 'BRANCH',
        listOperationId: ORGANIZATION_BRANCHES_LIST,
        detailOperationId: ORGANIZATION_BRANCHES_READ,
        listRouteId: ROUTE_IDS.ORGANIZATION_BRANCHES_LIST,
        detailRouteId: ROUTE_IDS.ORGANIZATION_BRANCHES_DETAIL,
        destinationStrategy: 'DETAIL',
        branchScopeMode: 'READABLE_BRANCHES',
        minimumQueryLength: 2,
        candidateLimit: 32,
        searchableFields: ['name', 'code'],
    },
    clients: {
        id: 'clients',
        resourceId: clients.id,
        entityType: 'CLIENT_ACCOUNT',
        listOperationId: clients.listOperationId,
        detailOperationId: clients.readOperationId,
        listRouteId: clients.listRouteId,
        detailRouteId: clients.detailRouteId,
        destinationStrategy: 'DETAIL',
        branchScopeMode: 'ACTIVE_BRANCH',
        minimumQueryLength: 2,
        candidateLimit: 32,
        searchableFields: ['fullName', 'code', 'email'],
    },
    portfolios: {
        id: 'portfolios',
        resourceId: portfolios.id,
        entityType: 'PORTFOLIO',
        listOperationId: portfolios.listOperationId,
        detailOperationId: portfolios.readOperationId,
        listRouteId: portfolios.listRouteId,
        detailRouteId: portfolios.detailRouteId,
        destinationStrategy: 'DETAIL',
        branchScopeMode: 'ACTIVE_BRANCH',
        minimumQueryLength: 2,
        candidateLimit: 32,
        searchableFields: ['accountNumber', 'boId', 'dpCode'],
        sensitiveDisplayFields: ['accountNumber', 'boId'],
    },
    instruments: {
        id: 'instruments',
        resourceId: INSTRUMENTS_RESOURCE.id,
        entityType: 'INSTRUMENT',
        listOperationId: INSTRUMENTS_RESOURCE.listOperationId,
        detailOperationId: INSTRUMENTS_RESOURCE.readOperationId,
        listRouteId: INSTRUMENTS_RESOURCE.listRouteId,
        detailRouteId: INSTRUMENTS_RESOURCE.detailRouteId,
        destinationStrategy: 'DETAIL',
        branchScopeMode: 'GLOBAL',
        minimumQueryLength: 2,
        candidateLimit: 32,
        searchableFields: ['symbol', 'instrumentName', 'securityName', 'isin'],
    },
    transactions: {
        id: 'transactions',
        resourceId: transactions.id,
        entityType: 'TRANSACTION',
        listOperationId: transactions.listOperationId,
        detailOperationId: transactions.readOperationId,
        listRouteId: transactions.listRouteId,
        detailRouteId: transactions.detailRouteId,
        destinationStrategy: 'DETAIL',
        branchScopeMode: 'ACTIVE_BRANCH',
        minimumQueryLength: 2,
        candidateLimit: 48,
        searchableFields: ['transactionNumber', 'id', 'instrumentSymbol'],
    },
    users: {
        id: 'users',
        resourceId: 'organization-users',
        entityType: 'USER',
        listOperationId: ORGANIZATION_USERS_LIST,
        detailOperationId: ORGANIZATION_USERS_READ,
        listRouteId: ROUTE_IDS.ORGANIZATION_USERS_LIST,
        detailRouteId: ROUTE_IDS.ORGANIZATION_USERS_DETAIL,
        destinationStrategy: 'DETAIL',
        branchScopeMode: 'GLOBAL',
        minimumQueryLength: 2,
        candidateLimit: 32,
        searchableFields: ['email', 'firstName', 'lastName'],
    },
});
export function getSmartSearchRecordProvider(id) {
    return SMART_SEARCH_RECORD_PROVIDER_REGISTRY[id];
}
